import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { RedirectError } from '#src/shared/error';

import type { LandingPageSlug, TemplatePageData } from './types';

const VALID_SLUGS: readonly string[] = [
	'start-a-healthcare-reform-petition',
	'how-to-start-a-petition',
	'start-a-local-municipal-reform-petition',
	'start-a-local-school-reform-petition',
	'start-an-education-reform-petition',
	'cambiemoscolombia',
] satisfies LandingPageSlug[];

function isValidSlug(slug: string): slug is LandingPageSlug {
	return VALID_SLUGS.includes(slug);
}

export async function getTemplatePageData(
	_utilityContext: UtilityContext,
	slug: string | undefined,
): Promise<TemplatePageData> {
	if (!slug || !isValidSlug(slug)) {
		throw new RedirectError({ url: '/lp/how-to-start-a-petition', reason: 'invalid-slug' });
	}

	return { slug };
}
